
<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>岗位中心</span><span>/</span><span>岗位列表</span></div>
    <div class="disFlex between user-search">
      <div>
        <el-button type="primary" @click="toAdd()">添加岗位</el-button>
      </div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-input v-model="formInline.keyword" placeholder="请输入岗位查询" suffix-icon="el-icon-search"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading" style="padding: 10px;background-color: #fff;">
      <el-table :data="tableData.rows" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column prop="name" fixed width="150" label="岗位名称">
        </el-table-column>
        <el-table-column prop="name" label="岗位说明">
        </el-table-column>
        <el-table-column prop="itype" label="状态" width="100" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.state==1">已启用</span>
            <span v-if="scope.row.state==0">已禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" width="120" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <el-button size="mini" circle type="success" icon="el-icon-edit" @click="toEdit(scope.row.id,1)">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" v-if="scope.row.state==0" placement="top">
              <el-button size="mini" circle type="warning" icon="el-icon-delete-solid" @click="delGw(scope.row.id)">
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['collapse', 'wjSrc','currentUser'],
    data() {
      return {
        formInline: {
          keyword: '',
          state: '',
          page: 1,
          rows: 10
        },
        tableData: {
          rows:[],
          total:0
        },
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
        loading: true,
        dialogCardVisible:false,
        creator:''
      }
    },
    methods: {
      getUserList: function() {
        this.loading = true;
        this.$axios.get('/system/gangwei/list.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.tableData = data;
          this.loading = false;
        })
      },
      toAdd: function() {
        this.$router.push('/Company/Addgw');
      },
      toEdit: function(id) {
        this.$router.push('/Company/Addgw?id=' + id);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      delGw: function(id) {
        this.$confirm('您确定要删除该岗位吗?', '删除岗位', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/system/gangwei/del.htm?id='+id, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            if(data.stat=='1'){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getUserList()
            }
          })
        }).catch(() => {
        });
      },
      //
      showCard:function(id){
        this.creator=id;
        var $this=this;
        setTimeout(function(){
          $this.dialogCardVisible=true;
        },300)
      }
    },
    computed: {

    },
    created: function() {
      // this.getUserList();
      this.$set(this.formInline,'cid',this.currentUser.cid)
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getUserList()
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .user-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .user-search .el-form-item {
    margin-bottom: 0;
  }

  .userInfoBlock {
    width: 256px;
    height: 168px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .userInfoBlock .userevery-header {
    height: 52px;
    opacity: 1;
    background: #e4f3fc;
    border-radius: 4px 4px 0px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    align-items: center;
    padding: 0 14px;
    color: #9a9a9a;
  }

  .fenge {
    padding: 0 19px;
  }

  .userInfoBlock .userevery-header img {
    padding-right: 6px;
  }

  .user-flex {
    margin-top: 10px;
    font-size: 14px;
    padding: 0 14px;
    align-items: center;
    line-height: 22px;
  }

  .likelabel {
    width: 90px;
    text-align: left;
  }

  .likename {
    color: rgba(0, 0, 0, 0.65);
  }

  .el-popover {
    padding: 0 !important;
    width: 110px !important;
    min-width: 110px !important;
  }

  .czitem-list {
    width: 110px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid #efefef;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/GwList.vue